import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import './ShareModalContent.scss'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'

class ShareModalContent extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      copied: false
    }

    this.handleKeyCopy = this.handleKeyCopy.bind(this)
  }

  handleKeyCopy (e) {
    const copied = !!e.metaKey && e.key.toLowerCase() === 'c'

    if (copied && this.state.inputSelected) {
      this.setState({ copied: true })
    }
  }

  componentDidMount () {
    document.addEventListener('keydown', this.handleKeyCopy)
  }

  componentWillMount () {
    document.removeEventListener('keydown', this.handleKeyCopy)
  }

  render () {
    return (
      <div className='ShareModalContent'>
        <Modal.Header>Share {this.props.item}</Modal.Header>
        <input
          readOnly
          value={this.props.urlToShare}
          className='ShareModalContent__text'
          onClick={e => {
            const inputField = e.target
            inputField.select()
            this.setState({ inputSelected: true })
          }}
          onBlur={() => {
            this.setState({ inputSelected: false })
          }}
        />
        <div className='ShareModalContent__caption'>
          {this.props.shareCaption}
        </div>
        <Modal.Footer>
          <div className='ShareModalContent__confirm'>
            {this.state.copied ? 'Successfully copied url' : null}
          </div>
          <CopyToClipboard
            text={this.props.urlToShare}
            onCopy={() => {
              this.setState({ copied: true })
            }}
          >
            <button className='grey'>Copy Link</button>
          </CopyToClipboard>

          <button className='btn alo-button' onClick={this.props.onHide}>
            Done
          </button>
        </Modal.Footer>
      </div>
    )
  }
}

ShareModalContent.propTypes = {
  onHide: PropTypes.func,
  urlToShare: PropTypes.string,
  shareCaption: PropTypes.string,
  item: PropTypes.string
}

export default ShareModalContent
